// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "images/js/" + chunkId + "." + "f238b618" + ".js";
};